export const features = [
  {
    id: 0,
    h: 'Video Introduction',
    b:
      'Show employers who you really are with a personalized 30-second video - we’ll coach you on how best to showcase YOU.',
    logo: 'video',
    img: '/img/accordion-video.png',
  },
  {
    id: 1,
    h: 'Resume Snapshot',
    b:
      'Quickly share your resume on or off the platform with a personalized link.',
    logo: 'resume',
    img: '/img/accordion-resume.png',
  },
  {
    id: 2,
    h: 'Analytics',
    b:
      'Visualise your profile activity with our very own analytics tool and optimize accordingly.',
    logo: 'analytics',
    img: '/img/accordion-analytics.png',
  },
  {
    id: 3,
    h: 'Verified References',
    b:
      'Display your references - hiring managers can verify them with a single click.',
    logo: 'verified',
    img: '/img/accordion-verified.png',
  },
  {
    id: 4,
    h: 'Calendar Integration',
    b:
      'Link your personal calendar so employers can easily schedule an interview.',
    logo: 'calendar',
    img: '/img/accordion-calendar.png',
  },
  {
    id: 5,
    h: 'In-App Messaging',
    b:
      'Communicate with interested employers directly inside the ClipHire app.',
    logo: 'in-app',
    img: '/img/accordion-in-app.png',
  },
];
